<template>
  <div>
    <v-centerForm>
      <template slot='left'>
        <el-form inline :model="searchForm" ref="searchForm" label-width="100px">
          <el-form-item label="订单号" prop="orderNo">
            <el-input placeholder="请输入订单号" v-model="searchForm.orderNo" clearable></el-input>
          </el-form-item>
          <el-form-item label="乘客姓名" prop="passengerName">
            <el-input placeholder="请输入乘客姓名" v-model="searchForm.passengerName" clearable></el-input>
          </el-form-item>
          <el-form-item label="申请状态" prop="status">
            <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
              <el-option label="待审批" value="pending"></el-option>
              <el-option label="已通过" value="approved"></el-option>
              <el-option label="已拒绝" value="rejected"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请时间">
            <el-date-picker
              v-model="searchForm.applyTimeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
            <el-button icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template slot='right'>
        <el-button icon="el-icon-refresh" @click="refresh">刷新</el-button>
      </template>
    </v-centerForm>

    <v-tableEncapsulation
      :loading="loadingBtn.tableLoading"
      :columnData="columnData"
      :tableSize="pagination.size"
      :tableData="tableData"
      :tableTotal="pagination.total"
      :currentPage="pagination.current"
      @currentPage="handleCurrentChange"
      @sizeChange="handleSizeChange">
      <el-table-column slot="status" label="状态" align="center" width="100px">
        <template slot-scope="scope">
          <el-tag :type="getStatusTagType(scope.row.status)" effect="dark">
            {{ scope.row.statusText }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column slot="operate" label="操作" align="center" width="150px" fixed="right">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status === 'pending'"
            type="text"
            size="small"
            @click="approve(scope.row)">
            审批
          </el-button>
          <el-button type="text" size="small" @click="viewDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </v-tableEncapsulation>

    <!-- 审批弹窗 -->
    <el-dialog title="改签审批" :visible.sync="approveDialogVisible" width="500px">
      <el-form :model="approveForm" ref="approveForm" :rules="approveRules" label-width="100px">
        <el-form-item label="订单号">
          <span>{{ approveForm.orderNo }}</span>
        </el-form-item>
        <el-form-item label="乘客姓名">
          <span>{{ approveForm.passengerName }}</span>
        </el-form-item>
        <el-form-item label="原航班">
          <span>{{ approveForm.originalFlight }}</span>
        </el-form-item>
        <el-form-item label="新航班">
          <span>{{ approveForm.newFlight }}</span>
        </el-form-item>
        <el-form-item label="改签费用">
          <span style="color: #f56c6c; font-weight: bold;">${{ approveForm.changeFee }}</span>
        </el-form-item>
        <el-form-item label="改签原因">
          <span>{{ approveForm.changeReason }}</span>
        </el-form-item>
        <el-form-item label="审批结果" prop="approveResult">
          <el-radio-group v-model="approveForm.approveResult">
            <el-radio label="approved">通过</el-radio>
            <el-radio label="rejected">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审批备注" prop="remark">
          <el-input
            type="textarea"
            v-model="approveForm.remark"
            :rows="4"
            placeholder="请输入审批备注">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="approveDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="loadingBtn.approveLoading" @click="submitApprove">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { queryChangeList, approveChange } from '@/api/order/orderApi'

export default {
  name: 'changeList',

  data () {
    return {
      searchForm: {
        orderNo: null,
        passengerName: null,
        status: null,
        applyTimeRange: null
      },
      loadingBtn: {
        tableLoading: false,
        approveLoading: false
      },
      columnData: [
        {
          type: 'index',
          label: '序号',
          width: '60px'
        },
        {
          label: '订单号',
          prop: 'orderNo',
          width: '180px'
        },
        {
          label: '乘客姓名',
          prop: 'passengerName',
          width: '120px'
        },
        {
          label: '原航班',
          prop: 'originalFlight',
          width: '120px'
        },
        {
          label: '新航班',
          prop: 'newFlight',
          width: '120px'
        },
        {
          label: '改签费用',
          prop: 'changeFee',
          width: '120px'
        },
        {
          label: '改签原因',
          prop: 'changeReason',
          width: '150px'
        },
        {
          label: '申请时间',
          prop: 'applyTime',
          width: '160px'
        },
        {
          slot: 'status'
        },
        {
          label: '审批人',
          prop: 'approver',
          width: '120px'
        },
        {
          label: '审批时间',
          prop: 'approveTime',
          width: '160px'
        },
        {
          slot: 'operate'
        }
      ],
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      approveDialogVisible: false,
      approveForm: {
        id: null,
        orderNo: '',
        passengerName: '',
        originalFlight: '',
        newFlight: '',
        changeFee: 0,
        changeReason: '',
        approveResult: 'approved',
        remark: ''
      },
      approveRules: {
        approveResult: [
          { required: true, message: '请选择审批结果', trigger: 'change' }
        ]
      }
    }
  },

  methods: {
    // 搜索
    search () {
      this.pagination.current = 1
      this.getTableData()
    },

    // 重置搜索
    resetSearch () {
      this.$refs.searchForm.resetFields()
      this.searchForm.applyTimeRange = null
      this.pagination.current = 1
      this.getTableData()
    },

    // 刷新
    refresh () {
      this.getTableData()
    },

    // 获取表格数据
    getTableData () {
      this.loadingBtn.tableLoading = true
      const params = {
        current: this.pagination.current,
        size: this.pagination.size,
        ...this.searchForm
      }

      // 处理日期范围
      if (params.applyTimeRange && params.applyTimeRange.length === 2) {
        params.applyTimeStart = params.applyTimeRange[0]
        params.applyTimeEnd = params.applyTimeRange[1]
      }
      delete params.applyTimeRange

      // 移除空值
      Object.keys(params).forEach(key => {
        if (params[key] === null || params[key] === '' || params[key] === undefined) {
          delete params[key]
        }
      })

      queryChangeList(params).then(({ data, code }) => {
        if (code === this.$constant.SUCCESS) {
          this.tableData = data.records || []
          this.pagination.total = data.total || 0
        }
        this.loadingBtn.tableLoading = false
      }).catch(() => {
        this.loadingBtn.tableLoading = false
      })
    },

    // 页码变化
    handleCurrentChange (current) {
      this.pagination.current = current
      this.getTableData()
    },

    // 每页条数变化
    handleSizeChange (size) {
      this.pagination.size = size
      this.pagination.current = 1
      this.getTableData()
    },

    // 审批
    approve (row) {
      this.approveForm = {
        id: row.id,
        orderNo: row.orderNo,
        passengerName: row.passengerName,
        originalFlight: row.originalFlight,
        newFlight: row.newFlight,
        changeFee: row.changeFee,
        changeReason: row.changeReason,
        approveResult: 'approved',
        remark: ''
      }
      this.approveDialogVisible = true
    },

    // 提交审批
    submitApprove () {
      this.$refs.approveForm.validate((valid) => {
        if (valid) {
          this.loadingBtn.approveLoading = true
          approveChange({
            id: this.approveForm.id,
            approveResult: this.approveForm.approveResult,
            remark: this.approveForm.remark
          }).then(({ code, msg }) => {
            if (code === this.$constant.SUCCESS) {
              this.$message.success(msg || '审批成功')
              this.approveDialogVisible = false
              this.getTableData()
            }
            this.loadingBtn.approveLoading = false
          }).catch(() => {
            this.loadingBtn.approveLoading = false
          })
        }
      })
    },

    // 查看详情
    viewDetail (row) {
      // TODO: 跳转到订单详情页
      this.$message.info('查看详情功能待实现')
    },

    // 获取状态标签类型
    getStatusTagType (status) {
      const statusMap = {
        pending: 'warning',
        approved: 'success',
        rejected: 'danger'
      }
      return statusMap[status] || 'info'
    }
  },

  created () {
    this.getTableData()
  }
}
</script>

<style lang="scss" scoped>
</style>
